module.exports = __webpack_public_path__ + "img/jifen5.54756358.png";